export function hasActiveQuery(search, filters) {
  if (search && search.trim() !== '') return true;
  return Object.values(filters).some((v) => (Array.isArray(v) ? v.length > 0 : !!v));
}

export function buildFilterParams(filters) {
  const params = {};
  Object.entries(filters).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      if (v.length > 0) params[k] = v.join(',');
    } else if (v) {
      params[k] = v;
    }
  });
  return params;
}
